import React from 'react';

import { InputText } from 'primereact/inputtext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface ChecklistGroupProps {
	// eslint-disable-next-line no-empty-pattern
	onChange: ({}: any) => void;
	// eslint-disable-next-line no-empty-pattern
	onDelete: ({}: any) => void;
	value: string;
	groupIndex: number;
}

const ChecklistGroup: React.FC<ChecklistGroupProps> = ({ onChange, onDelete, value, children }) => {
	return (
		<div className='checklistGroupContainer'>
			<div className='p-field checklistGroup'>
				<InputText
					className='p-mr-3'
					value={value}
					onChange={onChange}
					placeholder='Insira um título para o grupo'
				/>
				<FontAwesomeIcon icon={faTimes} size='1x' onClick={onDelete} cursor='pointer' />
			</div>
			{children}
		</div>
	);
};

export default ChecklistGroup;
